import Logins from '../Auth/Signin';
import ForgotPassword from '../Auth/ForgotPassword';
import ResetPassword from '../Auth/ResetPassword';
import ActivateLicense from '../Auth/ActivateLicense';

export const authRoutes = [
  { path: `${process.env.PUBLIC_URL}/login`, Component: <Logins /> },
  { path: `${process.env.PUBLIC_URL}/forgot-password`, Component: <ForgotPassword /> },
  { path: `${process.env.PUBLIC_URL}/reset-password/:_id`, Component: <ResetPassword /> },
  { path: `${process.env.PUBLIC_URL}/activate`, Component: <ActivateLicense /> },
];
